import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { TopRightCloseButton } from "../../Shift/BottomSheet/OnCallPlacement/TopRightCloseButton";

export interface BonusPaymentSheetProps {
  onClose?: () => void;
  modalState: UseModalState;
  title: string;
  description: string;
}

export function BonusPaymentSheet(props: BonusPaymentSheetProps) {
  const { modalState, onClose, title, description } = props;

  return (
    <BottomSheet modalState={modalState} onClose={onClose}>
      <TopRightCloseButton
        aria-label="Close bonus payment modal"
        onClick={() => {
          modalState.closeModal();
          onClose?.();
        }}
      />

      <Stack
        sx={(theme) => ({
          backgroundColor: theme.palette.background.tertiary,
          paddingTop: 8,
          paddingBottom: 12,
          paddingX: 5,
        })}
      >
        <BottomSheetIllustrationContent
          illustrationType="pay"
          title={title}
          description={description}
        />
      </Stack>
    </BottomSheet>
  );
}
